module.exports = __webpack_public_path__ + "img/rob.3165f58e.png";